import { Button } from '@mui/material'
import type React from 'react'
import { useContext } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LanguageContext } from '../util/LanguageContext'

type BackButtonProps = {
  title: string
  onClick: () => void
}

export const BackButton: React.FC<BackButtonProps> = props => {
  const auth = useAuth()
  // 文字列変換用
  const translation = useContext(LanguageContext)
  //多言語化対応
  const userLanguage = navigator.language || navigator.languages[0]
  const baseLanguage = userLanguage.split('-')[0]
  let backButtonJsx: JSX.Element = <></>
  switch (baseLanguage) {
    case 'de':
    case 'es':
    case 'it':
    case 'nl':
    case 'sv':
    case 'tr':
      if (props.title === translation['button_back_to_list']) {
        backButtonJsx = (
          <Button
            disabled={auth.isDisable}
            onClick={props.onClick}
            sx={{
              justifyContent: 'center',
              color: '#282828',
              font: 'normal normal bold 21px/29px Noto Sans JP',
              textAlign: 'center',
              border: '2px solid #282828',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                color: '#282828',
                backgroundColor: '#F4F4F4',
                opacity: 0.8,
              },
              boxShadow: '0px 2px 2px #00000014',
              height: '49px',
              width: '250px',
              borderRadius: '10px',
              alignItems: 'center',
            }}
          >
            {props.title}
          </Button>
        )
      } else {
        backButtonJsx = (
          <Button
            disabled={auth.isDisable}
            onClick={props.onClick}
            sx={{
              justifyContent: 'center',
              color: '#282828',
              font: 'normal normal bold 21px/29px Noto Sans JP',
              textAlign: 'center',
              border: '2px solid #282828',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                color: '#282828',
                backgroundColor: '#F4F4F4',
                opacity: 0.8,
              },
              boxShadow: '0px 2px 2px #00000014',
              height: '49px',
              width: '189px',
              borderRadius: '10px',
              alignItems: 'center',
            }}
          >
            {props.title}
          </Button>
        )
      }
      break
    default:
      backButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={props.onClick}
          sx={{
            justifyContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/29px Noto Sans JP',
            textAlign: 'center',
            border: '2px solid #282828',
            backgroundColor: '#FFFFFF',
            '&:hover': {
              color: '#282828',
              backgroundColor: '#F4F4F4',
              opacity: 0.8,
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '49px',
            width: '189px',
            borderRadius: '10px',
            alignItems: 'center',
          }}
        >
          {props.title}
        </Button>
      )
      break
  }

  return <>{backButtonJsx}</>
}
